var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__search--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22.707 21.295l-7.38-7.38a8.005 8.005 0 10-1.412 1.412l7.379 7.38a1 1 0 101.413-1.412zM3.037 9.023a5.99 5.99 0 115.99 5.99 5.99 5.99 0 01-5.99-5.99z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }